module.exports = __webpack_public_path__ + "img/finalLibertadores.84754ca5.jpg";